import React, { useEffect, useState } from "react";
import "../../../css/WeekTransPay.css";
import { fetchAsyncPayPerDay, payPerDay } from "../PaySlice";
import { handleDate, selectedDate } from "../../weather/WeatherSlice";
import {
  Tooltip,
  XAxis,
  CartesianGrid,
  Legend,
  YAxis,
  ResponsiveContainer,
  LineChart,
  Line,
} from "recharts";
import { useDispatch, useSelector } from "react-redux";

interface WeekTransPayProps {
  page: number;
  handlePage: (item: number) => void;
}

const WeekTransPay = ({ page, handlePage }: WeekTransPayProps) => {
  const dispatch = useDispatch();
  const PayPerDayData = useSelector(payPerDay);

  useEffect(() => {
    // 初回描画時に実行する処理
    dispatch(fetchAsyncPayPerDay(page));

    // 定期実行を設定
    const interval = setInterval(() => {
      dispatch(fetchAsyncPayPerDay(page));
    }, 60000); // 60秒ごとに実行

    // コンポーネントのクリーンアップ時にインターバルをクリア
    return () => clearInterval(interval);
  }, [dispatch, page]); // 依存配列にdispatchを含める

  //tooltipをカスタムして天気と連動
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload; // payloadからデータを取得

      // 親コンポーネントのstate更新関数を呼び出し
      dispatch(handleDate(data.week));

      return (
        <div className="tooltip">
          <p className="date">{data.week}</p>
          <p className="total">ライド金額 : {data.total}</p>
          <p className="ride">乗車金額 : {data.ride}</p>
          <p className="paid">支払金額 : {data.paid}</p>
        </div>
      );
    }

    return null;
  };

  return (
    <div
      className="week_pay_trans_container"
      onMouseOut={() => dispatch(handleDate(null))}>
      <div className="week_pay_title_container">
        <div className="back" onClick={() => handlePage(1)}>
          ←
        </div>
        <h2 className="week_pay_trans_title">乗車金額推移(7日間ごと)</h2>
        <div className="next" onClick={() => handlePage(-1)}>
          →
        </div>
      </div>
      <ResponsiveContainer
        height="75%"
        width="90%"
        minHeight={240}
        minWidth={300}>
        <LineChart data={PayPerDayData!} className="line_chart">
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="week" />
          <YAxis dataKey="total" />
          <YAxis dataKey="paid" />
          <YAxis dataKey="ride" />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Line
            type="monotone"
            dataKey="ride"
            stroke="#82ca9d"
            name="乗車金額"
          />
          <Line
            type="monotone"
            dataKey="paid"
            stroke="#8884d8"
            name="支払金額"
          />
          <Line
            type="monotone"
            dataKey="total"
            stroke="#f4a460"
            name="ライド金額"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default WeekTransPay;
